exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-list-item__container__3KYEP{position:relative;overflow:hidden}", ""]);

// exports
exports.locals = {
	"container": "video-list-item__container__3KYEP"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/compact/components/videos/video-list-item/video-list-item.styl
// module id = 2942
// module chunks = 1